import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";


export const getAbonnementUsage = async () => {
  const response = await axios.get(`${API_URL}/abonnements/usage`);
  return response.data;
};
